import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API } from '../../../../../core/constants'
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API as AWS_API } from 'aws-amplify';
import { SignoutConfirmationDialogComponent } from 'src/app/pages/components/signout-confirmation-dialog/signout-confirmation-dialog.component';
import { UserService } from 'src/app/core/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/core/services/storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-event-menu',
  templateUrl: './event-menu.component.html',
  styleUrls: ['./event-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventMenuComponent implements OnInit {

  showSubmenu: boolean = false;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  menuList: any = [];
  routerevents: any;
  slug_name: any;
  ticket_key: any;
  slugInfo: any;
  slugInfoSubscr: Subscription;
  expoInfo: any = [];
  streamInfo: any;
  subEvents: any;
  getCurrency: any;
  currentLocation: any;
  userId: any;
  streamId: any;
  expoListId: any;
  isLiveStream: any;
  publisherLiveStreamSubscription: Subscription;
  streamStatusSubscr: Subscription;
  streamStatus: any;
  streamDetailSubject: Subscription;
  showStreamMenu: boolean;
  userSubscriptionInfo: any;
  roomsList: any = [];
  isExpo: boolean = false;
  expoTicket: any = [];
  networkTicket: any = [];
  networkInfo: any = [];
  ticketSubscr: Subscription;
  ticketInfo: any;
  settingsJSON: any;
  userInfoId: any;
  screenStatusSubscription: Subscription;
  leftMenu: boolean = false;
  userIdParam: any;
  vodUrl: any;
  timezoneVal: any;
  assets_url = environment.assets_url;
  channelName:any;
  groupSlug: string = '';
  settingsDataSubscription: Subscription;
  settingsData: any = {};

  constructor(private commonSubscribeService: CommanSubscribeService,
    public router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private userService: UserService,
    private dialog: MatDialog,
    private storageService: StorageService,
    private titleService: Title) {
    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this.route && this.route.firstChild && this.route.firstChild.paramMap) {
          this.route.firstChild.paramMap.subscribe(
            (params: any): void => {
              let eventId;
              this.slug_name = this.slugInfo && this.slugInfo.slug ? this.slugInfo.slug : params.params['slug_name'];
              this.ticket_key = params.params['ticket_key'] ? params.params['ticket_key'] : params.params['eventId'];
              if (this.ticket_key) {
                let id = this.ticket_key;
                if (id && id.includes('-'))
                  eventId = id.split('-');
              }
              if (eventId)
                this.userInfoId = eventId[1];
              this.streamId = eventId ? eventId[0] : params.params['id'];
              this.userInfo = this.commonSubscribeService.userInfo;
            }
          );
        }
      }
    });
  }

  deviceInfo: any;
  ngOnInit() {
    this.timezoneVal = this.userService.getTimezone();
    this.vodUrl = this.storageService.getItem('vodUrl');
    this.channelName = this.route.firstChild?.snapshot.params['channelName'] || this.router.url.split('/')[1];
    this.groupSlug = this.route.firstChild?.snapshot.params['groupName'] || '';
    this.userIdParam = this.route.snapshot.queryParamMap.get('user_id');
    this.screenStatusSubscription = this.commonSubscribeService.getScreenStatus().subscribe(response => {
      this.leftMenu = response;
      let device = this.commonSubscribeService.getMobileOperatingSystem();
      if (device == 'ios' || device == 'android') {
        this.deviceInfo = device;
      }
      this.showSubmenu = this.leftMenu || device == 'ios' || device == 'android' ? true : false;
    });
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    if (device == 'ios' || device == 'android') {
      this.deviceInfo = device;
    }
    if (this.router.url.includes('/stream/') || this.router.url.includes('/watch/') || device == 'ios' || device == 'android')
      this.showSubmenu = true;
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.ticketSubscr = this.commonSubscribeService.getTicketDetails().subscribe(response => {
      this.ticketInfo = response;
      this.settingsJSON = JSON.parse(this.ticketInfo.stream_info.stream_info.settings_json);
      let expo = response['expo'];
      this.isExpo = expo == 1 ? true : false;
      this.networkInfo = response['networking'];
      this.buildMenuList();
    });
    this.userId = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id);
    this.slugInfo = this.commonSubscribeService.slugInfo;
    if (this.slug_name != '' && this.slug_name != undefined)
      this.getEventDetails();
    this.slugInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      this.ticket_key = this.storageService.getItem('ticket_key');
      let eventId;
      if (this.ticket_key) {
        if (this.ticket_key && this.ticket_key.includes('-'))
          eventId = this.ticket_key.split('-');
      }
      if (response.tickets) {
        let tickets = response['tickets'];
        if (tickets && tickets.length > 0) {
          this.expoTicket = tickets.filter(a => a.expo == 1);
          this.networkTicket = tickets.filter(a => a.networking.length > 0);
        }
      }
      let expo = response['expo'];
      if (response['expo'])
        this.isExpo = expo == 1 ? true : false;
      if (response['networking'])
        this.networkInfo = response['networking'];
      // if(response['price_details'])
      //   this.priceDetails = response['price_details'];
      response = (response.expo || response.stream_info) ? response.stream_info : response;
      this.slugInfo = response;
      this.settingsJSON = response.stream_info ? JSON.parse(response.stream_info.settings_json) : JSON.parse(response.settings_json);
      this.slug_name = this.slugInfo.slug;
      this.streamId = this.streamId ? this.streamId : this.slugInfo.id;
      if (!this.streamId) {
        this.streamId = eventId[0];
      }
      if (!this.router.url.includes('/place-order')) {
        if ((this.router.url.includes('/stream/') && ((this.expoTicket && this.expoTicket.length == 0) || (this.networkTicket && this.networkTicket.length == 0)) && this.slugInfo) || (this.router.url.includes('/event/expo-list') || (this.router.url.includes('/event/networking-list'))))
          this.getEventDetails();
        // if (this.streamId && this.expoInfo && this.expoInfo.length == 0) {
        //   this.getExpoList();
        // }
      }

      // if (this.streamId && this.roomsList && this.roomsList.length == 0) {
      //   this.getNetworkRoomsList();
      // }


      // if (this.ticket_key == undefined && Object.keys(this.slugInfo).length > 0)
      //   this.ticket_key = this.slugInfo.stream_info.slug;
      this.buildMenuList();
    });
    this.publisherLiveStreamSubscription = this.userService.getIsSubscribed().subscribe(response => {
      this.isLiveStream = response;
    })

    this.streamStatusSubscr = this.userService.getStreamStatus().subscribe(response => {
      this.streamStatus = response;
    });

    this.streamDetailSubject = this.userService.getsetStreamDetailToStreamHeader().subscribe(response => {
      this.subEvents = response.beforeReplace_stream_info && response.beforeReplace_stream_info.subEvents ? response.beforeReplace_stream_info.subEvents : response.subEvents;
      if (response.stream_info)
        this.showStreamMenu = true;
    });

    this.buildMenuList();
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    })
  }

  redirectToChannel() {
    let url = this.vodUrl.split('/');
    this.router.navigate(['/' + url[1]]);
  }

  buildMenuList() {
    const base = this.groupSlug ? `${this.channelName}/${this.groupSlug}` : `${this.channelName}`;
    let allowToExpo = false;
    if (this.userSubscriptionInfo) {
      this.expoTicket.forEach(element => {
        if (this.userSubscriptionInfo[0] && this.userSubscriptionInfo[0].ticketIDs.includes(element.id)) {
          allowToExpo = true
        }
      });
    }
    this.expoListId = this.ticket_key ? this.ticket_key : this.streamId;
    let eventHome = this.ticket_key ? `${base}/event/home/${this.slug_name}/${this.ticket_key}` : `${base}/event/${this.slug_name}`
    let expoLink = this.expoTicket && this.ticket_key && (!this.isExpo && !allowToExpo) ? `${base}/event/${this.slug_name}/place-order/${this.ticket_key}` : `${base}/event/expo-list/${this.expoListId}`
    this.menuList = [
      {
        image: "home-white",
        active_image: "home-green",
        name: "Home",
        link: eventHome,
        activeMenuLink: [`${base}/event/home`, '/place-order'],
        sub_menu: []
      },
      {
        image: "streaming-white",
        active_image: "streaming-green",
        name: "Streaming",
        link: `${base}/event/schedule/${this.ticket_key}`,
        activeMenuLink: [`${base}/event/schedule`, '/stream/', '/watch'],
        sub_menu: [],
        hide: this.subEvents && this.subEvents.length == 1 && this.expoInfo && this.expoInfo.length == 0 && this.roomsList && this.roomsList.length == 0 ? true : false
      },
      {
        image: "community-white",
        active_image: "community-green",
        name: "Community",
        activeMenuLink: [`${base}/event/expo-list/`, `${base}/event/expo-details`, `${base}/event/expo-room`, `${base}/event/private-chat/list`, `${base}/event/contacts/list`, `${base}/event/networking-list`, `${base}/event/network-room`],
        sub_menu: [
          {
            menu_name: "Expo",
            link: expoLink,
            hideSubMenuLink: (this.settingsJSON && this.settingsJSON.expo != 1) || (this.expoInfo && this.expoInfo.length == 0) || (this.expoTicket && this.expoTicket.length == 0 && !this.isExpo) ? true : false
          },
          {
            menu_name: "Networking",
            link: `${base}/event/networking-list/${this.expoListId}`,
            hideSubMenuLink: (this.settingsJSON && this.settingsJSON.networking != 1) || (this.roomsList && this.roomsList.length == 0) || (this.networkTicket && this.networkTicket.length == 0 && this.networkInfo.length == 0) ? true : false
          },
          {
            menu_name: "Private Chat",
            type: "Private Chats",
            link: `${base}/event/private-chat/${this.ticket_key}`
          },
          {
            menu_name: "Contacts",
            type: "Contacts",
            link: `${base}/event/contacts/${this.ticket_key}`
          },
        ]
      },

    ];

    this.goToMenu(this.router.url, false);
  }

  goToMenu(link, doCallApi, name?) {
    if (name == 'Expo' && !this.ticket_key || (name == 'Expo' && this.expoInfo && this.expoInfo.length == 0)) {
      return;
    }
    if (name == 'Networking' && !this.ticket_key || (name == 'Networking' && this.roomsList && this.roomsList.length == 0)) {
      return;
    }
    if (this.isLiveStream == true && name && this.streamStatus != 'completed') {
      const dialogRef = this.dialog.open(SignoutConfirmationDialogComponent, {
        width: '370px',
        panelClass: 'app-signout-confirmation',
        data: this.isLiveStream
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == "yes") {
          this.redirectTo(link, name,doCallApi);
        }
      });
    } else {
      this.redirectTo(link, name,doCallApi);
    }

    if ((name == 'Expo' || name == 'Networking') && link.includes('place-order')) {
       this.showSubmenu = !this.showSubmenu;
    }
    if ((name == 'Expo' || name == 'Networking' || name == 'Streaming' || name == 'Private Chat' || name == 'Contacts') && !link.includes('place-order') && this.ticket_key) {
       this.commonSubscribeService.sendScreenStatus(false);
    }

  }

  redirectTo(link, name, doCallApi: any) {
    const base = this.groupSlug ? `${this.channelName}/${this.groupSlug}` : `${this.channelName}`;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;

    (window as any).umami?.track(`Going back from streaming page - ${userId}`)
     const u_payload = {
        actionType: "event",
        metaData: {
          title: `Going back from streaming page`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
        clickAction: `stream`
    }
    if (name == 'Streaming' && (this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length == 0 || !this.ticket_key)) {
      return;
    } else if (name == 'Expo' && !this.isLiveStream && (!this.ticket_key || (this.expoInfo && this.expoInfo.length == 0))) {
      return;
    } else if (name == 'Networking' && !this.isLiveStream && (this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length == 0 || this.roomsList && this.roomsList.length == 0)) {
      return;
    } else if ((name == 'Private Chat' || name == 'Contacts') && this.ticket_key == undefined) {
      return;
    } else {
      if(doCallApi){
        this.commonSubscribeService.sendTriggeredEvent(u_payload);
      }
      
      if (name == 'Streaming' && this.expoInfo.length == 0 && ((this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status != 'completed') || (this.slugInfo && this.slugInfo.subEvents && this.slugInfo.subEvents.length == 1 && this.slugInfo.subEvents[0].stream_status != 'completed'))) {
        this.router.navigate([`${base}/stream/` + this.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
        return false;
      } else if (name == 'Streaming' && this.expoInfo.length == 0 && ((this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed') || (this.slugInfo && this.slugInfo.subEvents && this.slugInfo.subEvents.length == 1 && this.slugInfo.subEvents[0].stream_status == 'completed'))) {
        this.router.navigate([`${base}/watch/` + this.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
        return false;
      } else {
        this.router.navigateByUrl(link);
        this.setActiveLink(link);
      }
    }
  }

  setActiveLink(link) {
    this.menuList.forEach(firstMenu => {
      firstMenu.activeMenu = false;
      if ((!firstMenu.sub_menu || firstMenu.sub_menu.length == 0) && firstMenu.link && link.indexOf(firstMenu.link) != -1) {
        firstMenu.activeMenu = true;
      } else if (firstMenu.activeMenuLink && firstMenu.activeMenuLink.length > 0 && this.checkSubLinkActive(firstMenu.activeMenuLink, link)) {
        firstMenu.activeMenu = true;
      }

      if ((firstMenu.sub_menu && firstMenu.sub_menu.length > 0)) {
        firstMenu.sub_menu.forEach(secondMenu => {
          secondMenu.activeMenu = false;
          if ((!secondMenu.sub_menu || secondMenu.sub_menu.length == 0) && secondMenu.link && link.indexOf(secondMenu.link) != -1 && !link.includes('place-order')) {
            firstMenu.activeMenu = true;
            secondMenu.activeMenu = true;
          } else if (secondMenu.activeMenuLink && secondMenu.activeMenuLink.length > 0 && this.checkSubLinkActive(secondMenu.activeMenuLink, link)) {
            secondMenu.activeMenu = true;
          }
        });
      }
    });
  }

  checkSubLinkActive(activeMenuLink, link) {
    let isActive = false;
    activeMenuLink.forEach(e => {
      if (link.indexOf(e) != -1) {
        isActive = true;
      }
    });
    return isActive;
  }

  getExpoList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_LIST + '/' + this.streamId;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.expoInfo = response.data.Data;
        this.buildMenuList();
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  getNetworkRoomsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_ROOMS_LIST + '/' + this.streamId;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        if (response.data.Data) {
          this.roomsList = response.data.Data;
          this.buildMenuList();
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  priceDetails: any;
  getEventDetails() {
    this.getCurrency = this.storageService.getItem('currency');
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "userid": this.userId ? this.userId : this.userInfoId,
        "slug": this.slug_name,
        "offset": new Date().getTimezoneOffset(),
        "currency": this.getCurrency ? this.getCurrency : code,
        "timezone": this.timezoneVal
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
      if (response.data.message === "Success") {
        this.getPerformerDetails(response['data']['Data']);
        if (!this.router.url.includes(`${this.channelName}/event/expo-list`) && !this.router.url.includes(`${this.channelName}/stream/`) && !(this.groupSlug && this.router.url.includes(`${this.channelName}/${this.groupSlug}/stream/`)) && !this.router.url.includes(`${this.channelName}/event/networking-list`))
          this.commonSubscribeService.sendSlugData(response['data']['Data']);
        this.streamInfo = response['data']['Data']['stream_info'];
        // this.priceDetails = response['data']['Data']['price_details'];
        this.settingsJSON = JSON.parse(this.streamInfo.settings_json);
        this.userSubscriptionInfo = response['data']['Data']['user_subscription_info'];
        let tickets = response['data']['Data']['tickets'];
        if (tickets && tickets.length > 0) {
          this.expoTicket = tickets.filter(a => a.expo == 1);
          this.networkTicket = tickets.filter(a => a.networking.length > 0);
        }
        if (this.networkTicket && this.networkTicket.length > 0) {
          this.networkTicket.forEach(element => {
            if (this.userSubscriptionInfo && this.userSubscriptionInfo.length > 0)
              this.networkInfo = this.userSubscriptionInfo[0].networking;
          });
        }
        if (this.expoTicket && this.expoTicket.length > 0) {
          this.expoTicket.forEach(element => {
            if (this.userSubscriptionInfo && this.userSubscriptionInfo.length > 0 && this.userSubscriptionInfo[0].ticketIDs.includes(element.id))
              this.isExpo = true;
          });
        }
        if (this.userSubscriptionInfo && this.userSubscriptionInfo.length > 0)
          this.ticket_key = this.userSubscriptionInfo[0].ticket_key;
        // if (this.streamInfo && this.expoInfo.length == 0)
        //   this.getExpoList();
        // if (this.streamInfo && this.roomsList.length == 0)
        //   this.getNetworkRoomsList();
        this.subEvents = response['data']['Data']['subEvents'];
        if (this.router.url.includes('/claim-tickets/'))
          this.commonSubscribeService.sendSubEventsInfo(this.subEvents);
        this.buildMenuList();
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  getPerformerDetails(response) {
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "channel_name": response.performer_info.channel_name,
        "currency": this.getCurrency ? this.getCurrency : code,
        "user_id": this.userInfo ? this.userInfo.id : undefined
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
      this.commonSubscribeService.sendPerfomerInfo(response);
      const channelName = response?.data?.Data?.[0]?.channel_display_name;
      if (channelName) {
        this.titleService.setTitle(channelName);
      }

      // this.titleService.setTitle(response.data.Data[0].channel_display_name);

      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        let res = response.data.Data;
        if (res && res[0] && res[0].active_status == 1 && res[0].enable_channel == 1) {
          this.commonSubscribeService.performerStatusSubject.next(true);
        } else {
          this.commonSubscribeService.performerStatusSubject.next(false);
        }
      }

    });
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.slugInfoSubscr)
      this.slugInfoSubscr.unsubscribe();
    if (this.publisherLiveStreamSubscription)
      this.publisherLiveStreamSubscription.unsubscribe();
    if (this.streamStatusSubscr)
      this.streamStatusSubscr.unsubscribe();
    if (this.streamDetailSubject)
      this.streamDetailSubject.unsubscribe();
    if (this.ticketSubscr)
      this.ticketSubscr.unsubscribe();
    if (this.screenStatusSubscription)
      this.screenStatusSubscription.unsubscribe();
    if(this.settingsDataSubscription){
      this.settingsDataSubscription.unsubscribe();
    }
  }

}
